import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    paddingTop: 100,
    alignSelf: "flex-start",
    marginLeft: "10%",
  },
  titleText: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#077A97",
  },
  subtitle: {
    textAlign: "start",
    fontWeight: "500",
    marginTop: 70,
    fontSize: 18,
    color: "#000",
    lineHeight: 15.538, 
    paddingVertical: 15,
  },
});

export default styles;
